import CleanPressImg1PNG from 'assets/images/pricing_images/pricing_cp_1.png';
import CleanPressImg1 from 'assets/images/pricing_images/pricing_cp_1.webp';
import CleanPressImg2PNG from 'assets/images/pricing_images/pricing_cp_2.png';
import CleanPressImg2 from 'assets/images/pricing_images/pricing_cp_2.webp';
import HomeCareImg1PNG from 'assets/images/pricing_images/pricing_hc_1.png';
import HomeCareImg1 from 'assets/images/pricing_images/pricing_hc_1.webp';
import HomeCareImg2PNG from 'assets/images/pricing_images/pricing_hc_2.png';
import HomeCareImg2 from 'assets/images/pricing_images/pricing_hc_2.webp';
import PressOnlyImg1PNG from 'assets/images/pricing_images/pricing_po_1.png';
import PressOnlyImg1 from 'assets/images/pricing_images/pricing_po_1.webp';
import PressOnlyImg2PNG from 'assets/images/pricing_images/pricing_po_2.png';
import PressOnlyImg2 from 'assets/images/pricing_images/pricing_po_2.webp';
import WashFoldImg1PNG from 'assets/images/pricing_images/pricing_wf_1.png';
import WashFoldImg1 from 'assets/images/pricing_images/pricing_wf_1.webp';
import WashFoldImg2PNG from 'assets/images/pricing_images/pricing_wf_2.png';
import WashFoldImg2 from 'assets/images/pricing_images/pricing_wf_2.webp';

const data = new Map([
  [
    'HOME_CARE',
    {
      content: [
        {
          poster: HomeCareImg1,
          posterFallback: HomeCareImg1PNG,
        },
        {
          poster: HomeCareImg2,
          posterFallback: HomeCareImg2PNG,
        },
        // {
        //   poster: HomeCareImg3,
        //   video: HomeCareVideo,
        // },
      ],
      title: 'pricingPage.home_care_pricing_description',
    },
  ],
  [
    'PRESS',
    {
      content: [
        {
          poster: PressOnlyImg1,
          posterFallback: PressOnlyImg1PNG,
        },
        {
          poster: PressOnlyImg2,
          posterFallback: PressOnlyImg2PNG,
        },
        // {
        //   poster: PressOnlyImg3,
        //   video: PressOnlyVideo,
        // },
      ],
      title: 'pricingPage.press_only_pricing_description',
    },
  ],
  [
    'CLEAN_PRESS',
    {
      content: [
        {
          poster: CleanPressImg1,
          posterFallback: CleanPressImg1PNG,
        },
        {
          poster: CleanPressImg2,
          posterFallback: CleanPressImg2PNG,
        },
        // {
        //   poster: CleanPressImg3,
        //   video: CleanPressVideo,
        // },
      ],
      title: 'pricingPage.clean_press_pricing_description',
    },
  ],
  [
    'WASH_FOLD',
    {
      content: [
        {
          poster: WashFoldImg1,
          posterFallback: WashFoldImg1PNG,
        },
        {
          poster: WashFoldImg2,
          posterFallback: WashFoldImg2PNG,
        },
        // {
        //   poster: WashFoldImg3,
        //   video: WashFoldVideo,
        // },
      ],
      title: 'pricingPage.wash_fold_pricing_description',
    },
  ],
]);

export default data;
